module.exports.labelOverrides = {
  xc_energy: "XC Energy",
  vdw_energy: "vdW Energy",
  ts_energy: "TS Energy",
  xc_functional: "XC Functional",
  vdw_correction: "vdW Correction",
  number_electrons_initial: "Initial Electron Count",
  number_electrons_final: "Final Electron Count",
  Nexplicitwater: "Explicit Water Count",
  pcm_variant: "PCM Variant",
  is_gcdft: "Is GCDFT",
  kgrid: "K-Grid",
  spintype: "Spin Type",
  Nbands: "Bands",
  Nkpoints: "K-Points",
  Kgrid: "K-Grid",
  coulomb_truncation_Rc: "Coulomb Truncation RC",
};

module.exports.columnOverrides = {
  adsorbate_formula: "Adsorbate",
};
